import React from 'react';
import TextFilter from '@app/components/data-grid/TextFilter';
import { UnitFragment } from '@app/generated/graphql';
import { Column } from 'react-data-grid';

export const projectonColumns: Column<UnitFragment>[] = [
  {
    key: 'id',
    name: 'ID',
    filterRenderer: (p) => <TextFilter {...p} />,
    resizable: true,
  },
  {
    key: 'description',
    name: 'คำอธิบาย หน่วยนับ',
    filterRenderer: (p) => <TextFilter {...p} />,
    resizable: true,
  },
];
